import { createRequestActions } from '../utils';
import * as phraseTRTypes from './phraseTRTypes';

export const saveTranslation = createRequestActions(phraseTRTypes.SAVE_TRANSLATION, (data) => ({
  data,
}));
export const listPhraseTranslation = createRequestActions(phraseTRTypes.PHRASE_TRANSLATION_LIST);
